<template>
  <div class="q-ml-sm text-brand-5 text-weight-bold titulo-input">
    {{ label }}
  </div>
  <q-select
    dense
    v-model="model"
    use-input
    hide-selected
    fill-input
    outlined
    class="select-btn"
    input-debounce="0"
    :options="options"
    behavior="menu"
    @filter="filterFn"
    :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
  >
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">Sem resultados</q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: ["unidade", "label"],
  setup(props, { emit }) {
    const store = useStore();
    const options = ref([]);
    const funcionariosData = ref([]);
    let model = ref(null);

    const getData = async (val) => {
      try {
        if (val.length >= 3) {
          let resposta = await store.dispatch("pdt/getFuncionarios", {
            unidade: props.unidade,
            busca: val,
          });

          options.value = [];
          funcionariosData.value = [];

          let funcionarios = [];

          if (resposta.data?.resultado?.dados) {
            funcionarios = resposta.data.resultado.dados;
          } else if (resposta.data?.data) {
            funcionarios = resposta.data.data;
          } else if (resposta.data) {
            funcionarios = resposta.data;
          } else if (Array.isArray(resposta)) {
            funcionarios = resposta;
          }

          funcionarios.forEach((e) => {
            const optionValue = `${e.nome} - ${e.sap}`;
            options.value.push(optionValue);

            let userId = null;
            const possibleUserIdFields = [
              "userId",
              "funcionarioId",
              "id",
              "user_id",
              "sap",
              "matricula",
            ];

            for (const field of possibleUserIdFields) {
              if (e[field] !== undefined && e[field] !== null) {
                userId = e[field];
                break;
              }
            }

            if (!userId) {
              console.error(
                "ATENÇÃO: Nenhum userId encontrado para este funcionário!"
              );
            }

            const funcionarioData = {
              nome: e.nome,
              matricula: e.sap,
              sap: e.sap,
              userId: userId,
              funcionarioId: e.funcionarioId || e.id,
              optionValue: optionValue,
              dadosCompletos: e,
              cargo: e.cargo || e.function || null,
            };

            funcionariosData.value.push(funcionarioData);
          });
        }
      } catch (error) {
        console.error("Erro ao buscar funcionários:", error);
      }
    };

    watch(model, () => {
      if (model.value) {
        const funcionarioSelecionado = funcionariosData.value.find(
          (f) => f.optionValue === model.value
        );

        emit("selectValue", model.value, funcionarioSelecionado);
      }
    });

    return {
      options,
      filterFn(val, update, abort) {
        if (val.length < 3) {
          abort();
          return;
        }
        getData(val);
        setTimeout(() => {
          update();
        }, 1000);
      },
      getData,
      model,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .titulo-input {
    font-size: 11px !important;
    margin: 0px;
  }
  .select-btn {
    font-size: 16px !important;
  }
}
</style>
